export default __webpack_public_path__ + "static/media/team_5.3cbaf33d.jpg";